import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { StateManagementService } from "providers/state-management/state-management.service";
import { Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { PlanOfCareDataService } from "../../../providers/poc-data-service/poc-data-service";

/**
 * Generated class for the SuggestedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: "page-suggested",
  templateUrl: "suggested.html",
})
export class SuggestedPage {
  suggestedIssues: any = {};
  selectedData: object = null;
  private addPocIssue: boolean;
  private subscriptions = new Subscription();
  constructor(
    private dataService: PlanOfCareDataService,
    public navCtrl: NavController,
    public navParams: NavParams,
    public stateData: StateManagementService
  ) {}

  ionViewWillEnter() {
    // SUP-19982: takeUntil(logout$) releases this before resetState() broadcasts
    // addPocIssue.next(null) on sign-out, which otherwise made every accumulated
    // subscription re-issue getIssues(). Tracked + released in ionViewWillLeave so
    // re-entering the tab does not stack another subscriber.
    this.subscriptions.add(
      this.stateData.addPocIssue
        .pipe(takeUntil(this.stateData.logout$))
        .subscribe((x) => {
          if (x !== null) {
            this.addPocIssue = x;
          }
          this.getIssues();
        })
    );
    this.dataService.getIssuesCount();
  }

  ionViewWillLeave() {
    this.subscriptions.unsubscribe();
    this.subscriptions = new Subscription();
  }

  select(data) {
    this.selectedData = this.selectedData === data ? null : data;
  }

  updateIssuesList(event: { action: string; data: any }) {
    let action = event.action,
      data = event.data;

    //accept and decline both remove elements from array
    if (action === "acceptIssue" || action === "declineIssue") {
      let index = this.suggestedIssues.issues.indexOf(data);
      this.suggestedIssues.issues.splice(index, 1);

      if (this.selectedData === data) {
        this.selectedData = null;
      }
    }
  }

  getIssues() {
    let getIssues = this.addPocIssue
      ? this.dataService.getIssuesWithPermissions("CL007.4")
      : this.dataService.getIssues("CL007.4");

    getIssues.subscribe(
      (data) => {
        this.suggestedIssues = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/plan-of-care/suggested/suggested.ts